import { METRIC_NAME, JS_SERVER_TYPE } from '@/constants';
import { monitorSingleJsLoadTime } from '@/utils';
import { asyncLoadFile } from '@/utils/asyncLoadFile';
import GlobalVariables, { GLOBAL_VARIABLES } from '@/utils/global.ts';

let __blackbox: string = ''
export function entry(data: typeof import('@/constants')['DEFAULT_ANTI_SPIDER']['td'], extra: { server_type: keyof typeof import('@/constants')['SERVER_TYPE']['production'], env: keyof typeof import('@/constants')['DEBUG_ENV'] }) {
    const { url, partner, appName, normal } = data[extra.server_type]
    const time = Date.now()
    window._fmOpt = {
        partner,
        appName,
        interfaceProtection: true,
        normalUrl: normal,
        token: `${appName}-${Date.now()}-${Math.random().toString(16).slice(2)}`,
        collectBehavior: true,
        success: (v: string) => {
            __blackbox = v;
        },
        error: () => {
            __blackbox = '';
        }
    };
    asyncLoadFile({
        label: 'script',
        attrs: {
            async: 'true',
            src: url
        },
    })
        .then(() => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadTD' },
                value: Date.now() - time,
                message: 'td load success',
            })
        }).then(() => {
            monitorSingleJsLoadTime('fm', JS_SERVER_TYPE[extra.env][extra.server_type]);
        })
        .catch(error => {
            GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                metric_name: METRIC_NAME,
                tags: { url, type: 'loadTDError' },
                value: Date.now() - time,
                message: 'td load error',
                params: error
            })
        })
}

export async function provideBlackbox(d: { validate_channel: string, brand: string }) {
    if (d.validate_channel == '0' || d.validate_channel == '1') {
        // pc pwa
        return __blackbox || ''
    }
    if (d.brand === 'shein') {
        // shein h5
        const _b = await sheinPost()
        return _b || ''
    }
    if (d.brand === 'romwe') {
        // romwe h5
        const _b = await romwePost()
        return _b || ''
    }
    return ''
}

async function romwePost() {
    const time = Date.now();
    try {
        if (!window?.Wing) return ''
        window?.Wing?.post('Common/get_risk_blackbox')
        return new Promise((resolve) => {
            setTimeout(() => { // 设置超时时间
                GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                    metric_name: METRIC_NAME,
                    tags: { type: 'loadTDError', url: 'romwe' },
                    value: Date.now() - time,
                    message: 'td load error',
                    params: { timeout: 1000 }
                })
                resolve('')
            }, 1000);
            window?.Wing?.on('get_risk_blackbox', (data: any) => {
                GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
                    metric_name: METRIC_NAME,
                    tags: { type: 'loadTD', url: 'romwe' },
                    value: Date.now() - time,
                    message: 'td load success',
                })
                resolve(data)
            })
        })
    } catch (error) {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadTDError', url: 'romwe' },
            value: Date.now() - time,
            message: 'td load error',
            params: error
        })
        return ''
    }
}

async function sheinPost() {
    const time = Date.now();
    try {
        if (!window?.Wing) return ''
        const { blackBox } = await window?.Wing?.postBridge('RiskBridge/getBlackbox', {}, 1000) || {}
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadTD', url: 'shein' },
            value: Date.now() - time,
            message: 'td load success',
        })
        return blackBox || ''
    } catch (error) {
        GlobalVariables.get(GLOBAL_VARIABLES.METRIC)?.({
            metric_name: METRIC_NAME,
            tags: { type: 'loadTDError', url: 'shein' },
            value: Date.now() - time,
            message: 'td load error',
            params: error
        })
        return ''
    }
}